const brRegulationBrands = [
    'belloatechbr0001', 'bet365br00000001', 'betfairbr0000001', 'bandbetbr0000001', 'betssonbr0000001',
    'ktobetbr00000001', 'leovegasbr000001', 'novibetbr0000001', 'reidopitacobr001', 'stakebr000000001',
    'lottolandbr00001', 'sorteonlinebr001', 'a8latam000000001', 'a8latam200000001', 'apostaganhacom01',
    'bet7kcom00000001', 'betconstructlat1', 'bingoemcasa00001', 'blazecom00000001', 'brbetesportecom1',
    'entainbr00000001', 'esportesdasorte1', 'estrelabet000001', 'ngxnv00000000001', 'stoss00000000001',
    'superbetbr000001', 'weebetbr00000001', 'brbetanocom00001'
];

module.exports = brRegulationBrands;
